import Route from '@ember/routing/route';

export default class KalenderRoute extends Route {}
